<div class="mb-3">
  @if (label != null) {
    <label for="{{ id }}">{{ label }}</label>
  }
  @if (showRequired) {
    <span class="required-indicator">*</span>
  }
  <input
    [readonly]="isReadOnly"
    placeholder="{{ placeholder }}"
    type="text"
    id="{{ id }}"
    class="form-control"
    maxlength="{{ maxLength }}"
    [formControl]="control"
    #inputControl
    />
    @if (showCharsUsed) {
      <p class="text-end">
        <small class="form-text text-muted">
          <code>{{ inputControl.value.length }}</code> of {{ maxLength }} characters used
        </small>
      </p>
    }
    @if (helperText.length > 0) {
      <p class="text-end">
        <small class="form-text text-muted">
          {{ helperText }}
        </small>
      </p>
    }
    @if (control.invalid) {
      <span class="help-block">
        <span class="required-indicator">
          {{ getErrorMessage() }}
        </span>
      </span>
    }
  </div>
